import { observer } from 'mobx-react-lite'
import React, { ReactElement } from 'react'
import BatchSend from './BatchSend'
import PageHeader from '../../components/PageHeader'
import { SecondaryLinkButton } from '../../components/Button'
import {
  DashboardPage,
  InlinePill,
  PageActionRow,
  PageHeaderRow,
  SurfaceHeader,
  SurfaceSubtext,
  SurfaceTitle
} from '../../components/DashboardPrimitives'
import { Container } from '../../components/Animations'
import { ROUTES, useTestMode } from '../../util/Util'
import { CenteredWorkspace, FlowSurface } from './SendStyles'

/**
 * Standalone batch-payout workbench. Batch lives beside — not inside — the
 * single-send flow: it is an operational product of its own (affiliate
 * payouts, creator payments, payroll runs), and fiat rails funded from USDC
 * will join the crypto rail here.
 */
const BatchPayouts = observer((): ReactElement => {
  const [testMode] = useTestMode()

  return <Container>
    <DashboardPage>
      <PageHeaderRow>
        <PageHeader title='Batch payouts' />
        <PageActionRow>
          <SecondaryLinkButton
            to={ROUTES.PAYOUTS}
            style={{ fontSize: 13, minHeight: 34, padding: '0 12px' }}>
            Payout history
          </SecondaryLinkButton>
          <InlinePill $tone={testMode ? 'amber' : 'green'}>{testMode ? 'Test mode' : 'Live mode'}</InlinePill>
        </PageActionRow>
      </PageHeaderRow>

      <CenteredWorkspace>
        <FlowSurface style={{ maxWidth: 900 }}>
          <SurfaceHeader>
            <div>
              <SurfaceTitle>Pay many recipients in one run</SurfaceTitle>
              <SurfaceSubtext>
                Build the list by hand, from a CSV, or from a saved list. Crypto today; fiat
                rails funded from your USDC are next.
              </SurfaceSubtext>
            </div>
          </SurfaceHeader>
          <BatchSend />
        </FlowSurface>
      </CenteredWorkspace>
    </DashboardPage>
  </Container>
})

export default BatchPayouts
